import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "../message/Message";
import SentFileService from "../../../services/AdminServices/SentFiles";

const initialState = {
  filesData: [],
  recentFiles:[], 
  loading: false,
  recentFilesLoad: false,
  error: null,
};

export const getAllFiles = createAsyncThunk(
  "files/getAllFiles",
  async (id, thunkAPI) => {
   
    try {
      debugger;
      const response = await SentFileService.getAllFiles(id);
      return response.data; // Ensure that this is the correct data structure
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message); // Send error message for better debugging
    }
  }
);


export const getRecentFiles = createAsyncThunk(
  "files/getRecentFiles",
  async (data, thunkAPI) => {
  
    try {
      const response = await SentFileService.getRecentFiles(data);
      return response.data; // Ensure that this is the correct data structure
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message); // Send error message for better debugging
    }
  }
);

const RecentFilesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllFiles.fulfilled, (state, action) => {
        console.log("Files data received:", action.payload);
        state.filesData = action.payload;
        state.loading = false;
      })
      .addCase(getAllFiles.rejected, (state, action) => {
        console.error("Error fetching files:", action.payload);
        state.filesData = [];
        state.loading = false;
      })


      .addCase(getRecentFiles.pending, (state) => {
        state.recentFilesLoad = true;
      })
      .addCase(getRecentFiles.fulfilled, (state, action) => {
        console.log("getRecentFiles data received:", action.payload);
        state.recentFiles = action.payload;
        state.recentFilesLoad = false;
      })
      .addCase(getRecentFiles.rejected, (state, action) => {
        console.error("Error fetching getRecentFiles:", action.payload);
        state.recentFiles = [];
        state.recentFilesLoad = false;
      });
  },
});

const { reducer } = RecentFilesSlice;
export default reducer;
